import HelpData from "./HelpData";
import HelpDocHeader from "./HelpDocHeader";

const HelpDocument = () => {

    return (
        <div className="h-[700px] bg-gray-50 border-b border-b-primary/40">
            <HelpDocHeader />
            <section className="px-6 py-8 max-w-7xl mx-auto">
                {HelpData.length === 0 ? (
                    <p className="text-center text-gray-500 text-sm">No results found.</p>
                ) : (
                    <div className="grid gap-8 md:grid-cols-3">
                        {HelpData.map((section, idx) => (
                            <div
                                key={idx}
                                className="bg-white rounded-lg shadow p-6 flex flex-col"
                            >
                                <h2 className="text-xl font-semibold text-blue-600 mb-4">
                                    {section.category}
                                </h2>
                                <ul className="space-y-2 text-lg text-gray-700">
                                    {section.tabs.map((tab, tabIdx) => (
                                        <li key={tabIdx}>
                                            <a
                                                href={`#${tab.link}`}
                                                className="cursor-pointer hover:underline hover:text-primary"
                                            >
                                                {tab.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default HelpDocument;